export const DocumentsConstants = {
    category: 'category',
    description: 'description',
    fileName: 'fileName',
    dateAdded: 'dateAdded',
    isSuppressed: 'isSuppressed'
};